<section [ngClass]="{'align-items-end': isMobileAndMultiSlice}">
    <div class="icon-credit-card">
        <img [src]="iconCard">
    </div>
    <div class="text-installment" [ngClass]="{'multislice-mobile': isMobileAndMultiSlice}">
        <p>Em até <span>{{maxInstallments}}x {{hasCardTax ? 'com' : 'sem'}} juros</span></p>
        <p>no cartão de crédito.</p>
    </div>
</section>